module.exports = __webpack_public_path__ + "static/media/eclairs.dd2e99ea.JPG";